import DOMPurify from 'dompurify';

/**
 * Safely write HTML content to a new browser window.
 * Uses DOMPurify to sanitize content before injecting.
 */
export const safeOpenHTMLWindow = (htmlContent) => {
  if (!htmlContent) return null;
  const sanitized = DOMPurify.sanitize(htmlContent, {
    WHOLE_DOCUMENT: true,
    ADD_TAGS: ['style', 'link', 'meta', 'title', 'head', 'body', 'html'],
    ADD_ATTR: ['media', 'charset', 'name', 'content', 'rel', 'href', 'type'],
  });
  const blob = new Blob([sanitized], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (printWindow) {
    printWindow.addEventListener('load', () => URL.revokeObjectURL(url));
  } else {
    URL.revokeObjectURL(url);
  }
  return printWindow;
};

/**
 * Sanitize HTML string for safe rendering in React.
 */
export const sanitizeHTML = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ['style'],
    ADD_ATTR: ['class', 'style'],
  });
};
